import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Chart, ChartOptions } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import { AssetsCounts } from '../../../models/assetsCounts.model';
import { AssetData } from '../../../models/assetData.model';
Chart.register(ChartDataLabels);

@Component({
  selector: 'lib-tagged-asset-breakdown',
  standalone: false,
  templateUrl: './tagged-asset-breakdown.component.html',
  styleUrl: './tagged-asset-breakdown.component.scss'
})
export class TaggedAssetBreakdownComponent {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  @Input() lineGraphData: any;
  @Input() counts!: AssetsCounts;
  @Output() getData = new EventEmitter<[number, string]>();
  @Input() customersData: AssetData = new AssetData();

  lineGraphColors: any [] = [];
  pageSize: number = 6;
  page: number = 0;
  graphType: string = 'Daily';
  graphDateType: string = 'LastUpdateTime';
  graphData: any = { labels: ['-'] };
  isFilterPopupVisible = false;

  title = 'ng2-charts-demo';

  public barChartLegend = true;
  public barChartPlugins = [ChartDataLabels];

  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 30
        },
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        // anchor: 'start',
        // align: 'end',
        // color: '#fff',
        // font: {
        //   weight: 'bold',
        //   size: 12,
        // },
        // formatter: (value: any) => value,
        // clamp: false,
        // clip: false,
        display: false
      }
    },
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
        },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          precision: 0,
        },
        grid: {
          display: false,
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false
    },
  };


  getGraphData(eventData: [number, string]){
    this.getData.emit(eventData);
  }

  setGraphType(period: 'Daily' | 'Monthly' | 'Yearly') {
    this.graphType = period;
    this.getGraphData([0, this.graphType]);
  }

  increasePage(val: number) {
    if (this.page + val >= 0) {
      this.page += val;
      this.getGraphData([this.page, this.graphType]);
    }
  }

  toggleFilterPopup() {
    this.isFilterPopupVisible = !this.isFilterPopupVisible;
  }

  toggleDatasetVisibility(index: number) {
    const chartInstance = this.chart?.chart;
    if (!chartInstance) return;

    const meta = chartInstance.getDatasetMeta(index);
    meta.hidden = !meta.hidden;

    chartInstance.update();
  }
}
